<template>
    <section>
        <FormSection
            :full-height="false"
            title="Reassign"
            :application-id="application"
            :show-product-pill="true"
            id="bulk-reassign"
        >
            <template v-slot:content>
                <section class="p-5 d-flex flex-column text-center text-primary" v-if="isLoading">
                    <i class="fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite"></i>
                    <b class="mt-1 big-text">Loading...</b>
                </section>
                <section v-else>
                    <div class="dialog container row m-0 p-1">
                        <div class="form-group col-10">
                            <label for="employee-to"> New User/Employee: </label>
                            <TypeaheadInput
                                :getData="filterEmployee"
                                :value="selectedEmployeeTo"
                                v-on:valueChanged="selectedEmployeeToChanged"
                                placeholder="Enter Employee Name"
                                :show-all-by-default="showAllByDefault"
                                v-on:blurredInput="v$.visitDetails.EmployeeTo.$touch"
                                :class="`${!v$.visitDetails.EmployeeTo.$error ? '' : 'field-invalid'}`"
                            />
                            <span v-if="v$.visitDetails.EmployeeTo.$error" class="field-invalid"
                                >Employee is required.</span
                            >
                        </div>
                        <div class="form-group col-10" v-if="isApplicationHomeCare">
                            <label for="employee-to"> Reason: </label>
                            <select
                                id="reason-type"
                                name="reason-type"
                                class="form-select"
                                v-model="visitDetails.TypeId"
                                @change="selectedType()"
                                :class="`${!v$.visitDetails.TypeId.$error ? '' : 'field-invalid'}`"
                                @blur="v$.visitDetails.TypeId.$touch"
                            >
                                <option :value="null">Select Type</option>
                                <option
                                    v-for="trackingType of trackingTypes"
                                    :value="trackingType.Id"
                                    :key="trackingType.Id"
                                >
                                    {{ trackingType.Name }}
                                </option>
                            </select>
                            <span v-if="v$.visitDetails.TypeId.$error" class="field-invalid">Type is required.</span>
                            <select
                                id="reason"
                                name="reason"
                                class="form-select mt-3"
                                v-model="visitDetails.ReasonId"
                                v-if="cpyTrackingReason.length > 0"
                                :class="`${!v$.visitDetails.ReasonId.$error ? '' : 'field-invalid'}`"
                                @blur="v$.visitDetails.ReasonId.$touch"
                            >
                                <option :value="null">Select Reason</option>
                                <option
                                    v-for="trackingReason of cpyTrackingReason"
                                    :value="trackingReason.Id"
                                    :key="trackingReason.Id"
                                >
                                    {{ trackingReason.Reason }}
                                </option>
                            </select>
                            <span v-if="v$.visitDetails.ReasonId.$error" class="field-invalid"
                                >Reason is required.</span
                            >
                        </div>
                    </div>
                </section>
            </template>
        </FormSection>
        <div class="d-flex justify-content-center mb-3 mt-1" v-if="!isLoading">
            <span v-if="isSaving">
                <button class="btn btn-primary">
                    <i class="fa fa-spinner fa-spin animated slow flash infinite"></i>
                </button>
            </span>
            <span v-else>
                <button class="btn btn-primary" @click="reassignVisit()">Reassign</button>
                <button type="button" class="ms-1 btn btn-md btn-outline-secondary" @click="cancel()">Cancel</button>
            </span>
        </div>
    </section>
</template>

<style src="./EmployeeBulkReassign.scss"></style>
<script lang="ts" src="./EmployeeBulkReassign.ts"></script>
